import * as React from 'react';
import { NavMenu } from '@shopify/app-bridge-react';
import {
  CATALOG_HOME,
  LICENSES_HOME,
  MEDIA_HOME,
  ORDERS_HOME,
  STOREFRONT_HOME,
} from '../navigation/sections';

/**
 * App navigation lives in the native Shopify admin sidebar (outside the app
 * iframe) via App Bridge's NavMenu — it renders nothing in-page. NavMenu wraps
 * the <ui-nav-menu> web component and takes plain `<a href>` children with
 * relative in-app paths; App Bridge intercepts the clicks and keeps the URL /
 * history in sync automatically (no ClientRouter / RoutePropagator needed).
 *
 * Exactly one child carries rel="home" to mark the app's landing page —
 * Dashboard. Per App Bridge, the rel="home" link is the home destination
 * reached via the app name/icon and is not repeated as a menu item; the
 * remaining links render as the visible sidebar entries.
 *
 * <ui-nav-menu> cannot nest items, and the App Bridge guidance for an app with
 * many destinations is to group related pages under subpages. So the peer-level
 * catalog pages collapse behind one Catalog entry (a path prefix whose siblings
 * are repeated in-page by `SectionNav`), while orders, licensing and the media
 * library stay top-level — burying a headline feature one click deeper costs
 * more than the shorter menu buys. See `navigation/sections.ts` for the map.
 *
 * Every route is always listed (nav links render in the admin chrome and can't
 * intercept clicks). Feature-gated destinations fire the upgrade upsell
 * themselves on landing when the plan doesn't include them.
 */
const AppNavigation: React.FC = () => {
  return (
    <NavMenu>
      <a href='/dashboard' rel='home'>
        Dashboard
      </a>
      <a href={CATALOG_HOME}>Catalog</a>
      <a href={MEDIA_HOME}>Media library</a>
      <a href={ORDERS_HOME}>Orders</a>
      <a href={LICENSES_HOME}>Licenses</a>
      <a href={STOREFRONT_HOME}>Storefront</a>
      <a href='/settings'>Settings</a>
    </NavMenu>
  );
};

export default AppNavigation;
